import React from 'react';

const Icon = ({ className }) => (
    <svg className={className} fill='#000' width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.0703 8L6 14.0703L7.5 15.5703L12.0703 11L16.6406 15.5703L18.1406 14.0703L12.0703 8Z" />
    </svg>
);

export default Icon;